"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDraggable = exports.throttle = void 0;

var _react = _interopRequireWildcard(require("react"));

var _helpers = require("../util/helpers");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Helpers
var throttle = function throttle(f) {
  var token = null;
  var lastArgs = null;

  var invoke = function invoke() {
    f.apply(void 0, _toConsumableArray(lastArgs));
    token = null;
  };

  var result = function result() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    lastArgs = args;

    if (!token) {
      token = requestAnimationFrame(invoke);
    }
  };

  result.cancel = function () {
    return token && cancelAnimationFrame(token);
  };

  return result;
}; // Use draggable


exports.throttle = throttle;

var useDraggable = function useDraggable(onDrag, onReposition, addtlXOffset, addtlYOffset, extraWidth, maxWidth) {
  var isMobile = window.innerWidth < 760; // This state doesn't change often, so it's fine to use useState

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      pressed = _useState2[0],
      setPressed = _useState2[1]; // Do not store position in useState! Even if you useEffect on
  // it and update `transform` CSS property, React still rerenders
  // on every state change, and it LAGS


  var position = (0, _react.useRef)({
    x: 0,
    y: 0
  });
  var previousTouch = (0, _react.useRef)(null);
  var size = (0, _react.useRef)({
    width: 0,
    height: 0
  });
  var ref = (0, _react.useRef)(); // We've moved the code into the hook, and it would be weird to
  // return `ref` and `handleMouseDown` to be set on the same element.
  // Why not just do the job on our own here and use a function-ref
  // to subscribe to `mousedown` too? It would go like this:

  var unsubscribe = (0, _react.useRef)();
  var legacyRef = (0, _react.useCallback)(function (elem) {
    ref.current = elem;

    if (unsubscribe.current) {
      unsubscribe.current();
    }

    if (!elem) {
      return;
    }

    var handleMouseDown = function handleMouseDown(event) {
      if (event.type.startsWith('touch')) {
        var touch = event.touches[0];
        previousTouch.current = touch;
      } // don't forget to disable text selection during drag and drop
      // operations


      event.target.style.userSelect = "none";
      setPressed(true);
    };

    if (isMobile) {
      elem.addEventListener("touchstart", handleMouseDown);
    } else {
      elem.addEventListener("pointerdown", handleMouseDown);
    }

    unsubscribe.current = function () {
      if (isMobile) {
        elem.removeEventListener("touchstart", handleMouseDown);
      } else {
        elem.removeEventListener("pointerdown", handleMouseDown);
      }
    };
  }, []); // Set the size on load

  (0, _react.useEffect)(function () {
    var elem = ref.current;
    var newSize = {
      width: elem.offsetWidth,
      height: elem.offsetHeight
    };
    size.current = newSize;
  }, []);
  (0, _react.useEffect)(function () {
    if (!ref.current || !position.current) {
      return;
    }

    var elem = ref.current;
    elem.style.marginLeft = "".concat(addtlXOffset, "px");
  }, [addtlXOffset]);
  (0, _react.useEffect)(function () {
    if (!ref.current || !size.current || !extraWidth) {
      return;
    }

    var s = size.current;
    var elem = ref.current;
    var newSize = {
      width: s.width + extraWidth.width,
      height: s.height
    };

    if (newSize.width > 0 && newSize.height > 0) {
      size.current = newSize;
      var useableWidth = newSize.width;
      elem.style.width = "".concat(useableWidth, "px");
      elem.style.maxWidth = "".concat(useableWidth, "px");
      elem.style.minWidth = "".concat(useableWidth, "px");
    }
  }, [extraWidth]);
  (0, _react.useEffect)(function () {
    // Why subscribe in a `useEffect`? because we want to subscribe
    // to mousemove only when pressed, otherwise it will lag even
    // when you're not dragging
    if (!pressed) {
      return;
    } // Updating the page without any throttling is a bad idea
    // requestAnimationFrame-based throttle would probably be fine,
    // but be aware that naive implementation might make element
    // lag 1 frame behind cursor, and it will appear to be lagging
    // even at 60 FPS.


    var handleMouseMove = throttle(function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (!ref.current || !position.current) {
        return;
      }

      var pos = position.current; // It's important to save it into variable here,
      // otherwise we might capture reference to an element
      // that was long gone. Not really sure what's correct
      // behavior for a case when you've been scrolling, and
      // the target element was replaced. probably some formulae
      // needed to handle that case...

      var elem = ref.current;
      var newX = null;
      var newY = null;
      var movementX = null;
      var movementY = null;
      var touch = null;

      if (event.type.startsWith('touch')) {
        // TOUCH EVENTS
        touch = event.touches[0];
        newX = previousTouch !== null && previousTouch !== void 0 && previousTouch.current ? parseInt(pos.x + (touch.pageX - previousTouch.current.pageX)) : touch.pageX; // New X pos

        newY = previousTouch !== null && previousTouch !== void 0 && previousTouch.current ? parseInt(pos.y + (touch.pageY - previousTouch.current.pageY)) : touch.pageY;
        movementX = previousTouch !== null && previousTouch !== void 0 && previousTouch.current ? touch.pageX - previousTouch.current.pageX : touch.pageX - pos.x; // Change in X pos

        movementY = previousTouch !== null && previousTouch !== void 0 && previousTouch.current ? touch.pageY - previousTouch.current.pageY : touch.pageY - pos.y;
        previousTouch.current = touch;
      } else {
        // POINTER/MOUSE EVENTS
        newX = parseInt(pos.x + event.movementX);
        newY = parseInt(pos.y + event.movementY);
        movementX = event.movementX;
        movementY = event.movementY;
      }

      var newPos = onDrag({
        x: newX,
        y: newY,
        movementX: movementX,
        movementY: movementY
      });

      if (newPos.x !== null && newPos.y !== null) {
        elem.style.transform = "translate(".concat(newPos.x, "px, ").concat(newPos.y, "px)");
        position.current = newPos;
        onReposition({
          x: parseInt(newPos.x - pos.x),
          y: parseInt(newPos.y - pos.y)
        });
      }
    });

    var handleMouseUp = function handleMouseUp(event) {
      event.preventDefault();
      event.stopPropagation();
      event.target.style.userSelect = "auto";

      if (event.type.startsWith('touch')) {
        previousTouch.current = null;
      }

      setPressed(false);
    }; // Subscribe to mousemove and mouseup on document, otherwise you
    // can escape bounds of element while dragging and get stuck
    // dragging it forever


    if (isMobile) {
      document.addEventListener("touchmove", handleMouseMove);
      document.addEventListener("touchend", handleMouseUp);
    } else {
      document.addEventListener("pointermove", handleMouseMove);
      document.addEventListener("pointerup", handleMouseUp);
    }

    return function () {
      handleMouseMove.cancel();

      if (isMobile) {
        document.removeEventListener("touchmove", handleMouseMove);
        document.removeEventListener("touchend", handleMouseUp);
      } else {
        document.removeEventListener("pointermove", handleMouseMove);
        document.removeEventListener("pointerup", handleMouseUp);
      }
    }; // If `onDrag` wasn't defined with `useCallback`, we'd have to
    // resubscribe to 2 DOM events here, not to say it would mess
    // with `throttle` and reset its internal timer
  }, [pressed, onDrag]); // Actually it makes sense to return an array only when
  // you expect that on the caller side all of the fields
  // will be usually renamed

  return [legacyRef, pressed];
};

exports.useDraggable = useDraggable;